import { SET_VALUE_ROUTING } from '../../../actions/eaTravelRates/routing';
import { routingRules } from './routing';

export const eaTravelRatesRules = (store, next, action) => {
    if (action.type.startsWith(SET_VALUE_ROUTING)) {
        return routingRules(store, next, action);
    }

    return null;
};
